import { categoryColorFormValue, categoryColorPayload } from "./categoryColor";

const isEnabled = (value) => (
  value === true || value === 1 || value === "1" || value === "true"
);

export const categoryEditFormValues = (detail = {}) => ({
  ...detail,
  is_hide_online_booking: isEnabled(detail?.is_hide_online_booking) ? 1 : "",
  ...(Object.prototype.hasOwnProperty.call(detail, "color") ? { color: categoryColorFormValue(detail.color) } : {}),
});

export const normalizeCategoryMutationValues = (values = {}) => ({
  ...values,
  is_hide_online_booking: isEnabled(values?.is_hide_online_booking),
  ...(Object.prototype.hasOwnProperty.call(values, "color") ? { color: categoryColorPayload(values.color) } : {}),
});
